// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-modal-button {
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 1.4rem;
}

.steps-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.steps-slider {
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: 100%;
}

.step-slide {
  flex: 0 0 100%;
  max-width: 100%;
  padding: 10px;
  padding-top: 10px;
  padding-bottom: 0;
  box-sizing: border-box;
}

.step-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.step-content p {
  margin: 0;
  font-size: 17px;
  color: #1b1b1b;
}

.step-header {
  font-size: 24px;
  font-weight: 700;
  color: #5616ea;
  margin-bottom: 10px;
}

.navigation-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.step-indicator {
  font-weight: 500;
  font-size: 0.95rem;
  color: #555;
  display: flex;
  justify-content: space-between;
  margin-left: -15px;
  margin-right: -20px;
  margin-bottom: 10px;
}

.webflow-close-modal-button {
  background-color: transparent;
  border: none;
  outline: none;
  transition: background-color 0.3s ease, transform 0.3s ease;
  cursor: pointer;
  font-size: 20px;
}

.webflow-close-modal-button:hover {
  transform: translateY(-1px);
}

.instruction-list {
  padding-left: 20px;
  margin: 0;
  font-size: 17px;
  color: #1c1c1c;
}

.instruction-list li {
  margin-bottom: 15px;
  line-height: 1.6;
}

.instruction-list li::marker {
  font-weight: 800;
  color: #5616ea;
}

.steps-add-bot-btn,
.steps-bot-btn {
  font-size: 14px;
  border: none;
  border-radius: 5px;
  transition: 0.2s ease, color 0.2s ease;
}

.steps-add-bot-btn {
  background-color: #5616ea;
  color: white;
  padding: 6px 14px 4px 10px;
  border-radius: 20px;
  margin: 0 6px;
  text-align: center;
}

.steps-bot-btn {
  background-color: #f9f9f9;
  color: rgb(58, 58, 58);
  padding: 8px;
  margin-left: 8px;
  border: 1px solid #ddd;
  flex: 1 1;
}

.steps-plan-info-action-button {
  border: none;
  background-color: #5616ea;
  font-size: 13px;
  text-align: center;
  padding: 4px;
  padding-right: 6px;
  padding-left: 6px;
  border-radius: 8px;
  color: white;
  transition: 0.2s ease, color 0.2s ease;
  margin-left: 5px;
}

.steps-plan-info-action-button-content {
  display: flex;
  gap: 3px;
  align-items: center;
}

@media (max-width: 768px) {
  .step-slide {
    padding: 0;
    padding-top: 5px;
  }

  .step-indicator {
    margin-left: -5px;
    margin-right: -5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WebflowStepsModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,2DAA2D;EAC3D,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".close-modal-button {\r\n  position: absolute;\r\n  top: 15px;\r\n  right: 15px;\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.steps-wrapper {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.steps-slider {\r\n  display: flex;\r\n  transition: transform 0.5s ease-in-out;\r\n  width: 100%;\r\n}\r\n\r\n.step-slide {\r\n  flex: 0 0 100%;\r\n  max-width: 100%;\r\n  padding: 10px;\r\n  padding-top: 10px;\r\n  padding-bottom: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.step-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.step-content p {\r\n  margin: 0;\r\n  font-size: 17px;\r\n  color: #1b1b1b;\r\n}\r\n\r\n.step-header {\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: #5616ea;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.navigation-buttons {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 20px;\r\n}\r\n\r\n.step-indicator {\r\n  font-weight: 500;\r\n  font-size: 0.95rem;\r\n  color: #555;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-left: -15px;\r\n  margin-right: -20px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.webflow-close-modal-button {\r\n  background-color: transparent;\r\n  border: none;\r\n  outline: none;\r\n  transition: background-color 0.3s ease, transform 0.3s ease;\r\n  cursor: pointer;\r\n  font-size: 20px;\r\n}\r\n\r\n.webflow-close-modal-button:hover {\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.instruction-list {\r\n  padding-left: 20px;\r\n  margin: 0;\r\n  font-size: 17px;\r\n  color: #1c1c1c;\r\n}\r\n\r\n.instruction-list li {\r\n  margin-bottom: 15px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.instruction-list li::marker {\r\n  font-weight: 800;\r\n  color: #5616ea;\r\n}\r\n\r\n.steps-add-bot-btn,\r\n.steps-bot-btn {\r\n  font-size: 14px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  transition: 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.steps-add-bot-btn {\r\n  background-color: #5616ea;\r\n  color: white;\r\n  padding: 6px 14px 4px 10px;\r\n  border-radius: 20px;\r\n  margin: 0 6px;\r\n  text-align: center;\r\n}\r\n\r\n.steps-bot-btn {\r\n  background-color: #f9f9f9;\r\n  color: rgb(58, 58, 58);\r\n  padding: 8px;\r\n  margin-left: 8px;\r\n  border: 1px solid #ddd;\r\n  flex: 1;\r\n}\r\n\r\n.steps-plan-info-action-button {\r\n  border: none;\r\n  background-color: #5616ea;\r\n  font-size: 13px;\r\n  text-align: center;\r\n  padding: 4px;\r\n  padding-right: 6px;\r\n  padding-left: 6px;\r\n  border-radius: 8px;\r\n  color: white;\r\n  transition: 0.2s ease, color 0.2s ease;\r\n  margin-left: 5px;\r\n}\r\n\r\n.steps-plan-info-action-button-content {\r\n  display: flex;\r\n  gap: 3px;\r\n  align-items: center;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .step-slide {\r\n    padding: 0;\r\n    padding-top: 5px;\r\n  }\r\n\r\n  .step-indicator {\r\n    margin-left: -5px;\r\n    margin-right: -5px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
